import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e2ad9b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "guest-container" }
const _hoisted_2 = { class: "guest-header" }
const _hoisted_3 = { class: "guest-content" }
const _hoisted_4 = { class: "guest-main" }
const _hoisted_5 = { class: "guest-sidebar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventGuestHeader = _resolveComponent("EventGuestHeader")!
  const _component_EventGuestImage = _resolveComponent("EventGuestImage")!
  const _component_EventGuestTitleBar = _resolveComponent("EventGuestTitleBar")!
  const _component_EventSchedule = _resolveComponent("EventSchedule")!
  const _component_SocialMediaButtons = _resolveComponent("SocialMediaButtons")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_ContactLeft = _resolveComponent("ContactLeft")!
  const _component_Copyrights = _resolveComponent("Copyrights")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_EventGuestHeader, {
        routeName: _ctx.schedule,
        stateMenuFilter: this.sortedDays()[0]
      }, null, 8, ["routeName", "stateMenuFilter"])
    ]),
    _createElementVNode("article", _hoisted_3, [
      _createElementVNode("section", _hoisted_4, [
        _createVNode(_component_EventGuestImage, {
          image: _ctx.image,
          title: _ctx.name
        }, null, 8, ["image", "title"]),
        _createVNode(_component_EventGuestTitleBar, {
          tagText: _ctx.tags,
          country: _ctx.country,
          origin: "aGuest"
        }, null, 8, ["tagText", "country"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event) => {
          return (_openBlock(), _createElementBlock("div", {
            key: event.id
          }, [
            _createVNode(_component_EventSchedule, {
              date: event.day,
              hour: event.hour,
              place: event.place,
              link: event.link,
              name: event.name,
              event: event
            }, null, 8, ["date", "hour", "place", "link", "name", "event"])
          ]))
        }), 128))
      ]),
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("div", {
          style: _normalizeStyle([
            this.facebook ||
            this.deezer ||
            this.twitter ||
            this.youtube ||
            this.spotify ||
            this.instagram ||
            this.soundcloud
              ? { display: 'flex' }
              : { display: 'none' },
          ])
        }, [
          _createVNode(_component_SocialMediaButtons, {
            instagram: _ctx.instagram,
            twitter: _ctx.twitter,
            facebook: _ctx.facebook,
            deezer: _ctx.deezer,
            spotify: _ctx.spotify,
            soundcloud: _ctx.soundcloud,
            youtube: _ctx.youtube
          }, null, 8, ["instagram", "twitter", "facebook", "deezer", "spotify", "soundcloud", "youtube"])
        ], 4),
        _createVNode(_component_TextField, { text: _ctx.description }, null, 8, ["text"]),
        _createVNode(_component_ContactLeft, {
          telephone: _ctx.telephone,
          website: _ctx.website,
          email: _ctx.email
        }, null, 8, ["telephone", "website", "email"]),
        _createVNode(_component_Copyrights, {
          text: _ctx.copyright,
          description: _ctx.description
        }, null, 8, ["text", "description"])
      ])
    ])
  ]))
}